<template>
  <div class="gif-object">
    <div v-if="!gif" class="search">
      <input type="text" ref="search" v-model="searchTerm" placeholder="search GIF..." @input="type">
    </div>
    <div v-if="!gif" class="results">
      <img v-for="gif in gifs" :src="gif" :key="gif" @click="select(gif)">
    </div>
    <div class="img-wrapper" v-else>
      <img class="gif" :src="gif" alt="">
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import _ from 'lodash';

const KEY = 'JDdcdX096ZojHhcq4PR3ZYnT8NAs570L';

export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      searchTerm: '',
      showingGifs: false,
      gifs: [],
      gif: null,
      searchTimeout: null
    }
  },
  methods: {
    type() {
      if (this.searchTimeout)
        clearTimeout(this.searchTimeout);

      this.searchTimeout = setTimeout(() => {
        this.searchGifs();
      }, 750);
    },
    searchGifs() {
      this.showingGifs = true;

      axios.get(`https://api.giphy.com/v1/gifs/search?api_key=${KEY}&q=${this.searchTerm}&limit=20`)
        .then(result => {
          this.gifs = result.data.data.map(gif => `https://media.giphy.com/media/${gif.id}/giphy.gif`);
        })
    },
    select(gif) {
      this.gif = gif;

      this.update();
    },
    applyUpdate(changes) {
      if (changes.gif) this.gif = changes.gif;
    },
    update() {
      this.$emit('input', {
        gif: this.gif
      })
    },
    onClickOutside() {

    }
  },
  computed: {

  },
  mounted() {
    this.gif = this.data.gif;
  },
  watch: {
    'gif': function() {
      if (this.gif) this.$parent.canChangeColour = false;
      else this.$parent.canChangeColour = true;

      this.$parent.canLock = false;
    }
  }
}
</script>

<style scoped>

.search > p {
  padding: 0;
  margin: 0;
}

.search > p > span {
  text-decoration: underline;
  cursor: pointer;
}

.results {
  margin: 5px 0 0 0;
  overflow-y: scroll;
  height: 175px;

  display: flex;
  flex-wrap: wrap;
}

.results > img {
  width: 50%;
  height: 50%;

  cursor: pointer;
}

.img-wrapper {
  width: 100%;
  height: 100%;
}

.img-wrapper > img {
  width: 100%;
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/GifObject.vue